import React from 'react';
import PropTypes from 'prop-types';
import grayLogo from '../../../../assets/images/Logo_Gray.svg';

function ConsultantReferralsReceived({ notOne, referralsPath }) {
  const plural = notOne ? 's' : '';

  return (
    <div className="modal-style style-guide">
      <div className="text-center title">
        <div><img src={grayLogo} alt="" height="38" width="90" /></div>
        <h1 className="modal-header">
          Clora has received your referral
          {plural}
          !
        </h1>
        <div className="subtext mx-2 mx-md-5">
          Thanks for spreading the word and helping more consultants find the right opportunities.
        </div>

        <div className="form-wrapper mb-0 mx-2 mx-md-5">
          <a
            href={referralsPath}
            className="btn btn-primary"
            id="consultant-track-recommendations"
          >
            Track my referrals
          </a>
        </div>
      </div>
    </div>
  );
}

ConsultantReferralsReceived.propTypes = {
  referralsPath: PropTypes.string.isRequired,
  notOne: PropTypes.bool,
};

ConsultantReferralsReceived.defaultProps = {
  notOne: true,
};

export default ConsultantReferralsReceived;
